export const MRR_FIELDS = [
    {
        label: 'Created At',
        value: 'createdAt',
    },
    {
        label: 'Number of Business',
        value: 'numberOfBusiness',
    },
    {
        label: 'MRR Business Value',
        value: 'mrrBusinessValue',
    },
];

export const MRR_VARIABLES = [
    {
        _id: 'createdAt',
        name: 'Created At',
        value: 'createdAt',
    },
    {
        _id: 'numberOfBusiness',
        name: 'Number of Business',
        value: 'numberOfBusiness',
    },
    {
        _id: 'mrrBusinessValue',
        name: 'MRR Business Value',
        value: 'mrrBusinessValue',
    },
];
